import React from 'react'
import Navbar from '../inc/Navbar'
import OurFacility from './OurFacility'
import maingateSRGCOMPLEX from "../images/main gate SRG Complex.jpg";

function Facilitypage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
         <br/>
            <div className='radius'>
            <div className="album py-1">
                <div className="container">
                   <img src={maingateSRGCOMPLEX} className="d-block w-100" alt="SRG Complex"/>
</div>
                    </div>
                </div>
                <br/>
        <OurFacility/>
        <br/>
    </div>
  )
}

export default Facilitypage